module.exports = __webpack_public_path__ + "img/qrcode.41e9d777.png";